import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { AdultRoute } from "./components/AdultRoute";
import { Nico } from "./components/Nico";
import { OfflineNotice } from "./components/OfflineNotice";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const AccessPage = lazy(() => import("./pages/AccessPage"));
const OnboardingPage = lazy(() => import("./pages/OnboardingPage"));
const WorldPage = lazy(() => import("./pages/WorldPage"));
const SessionPage = lazy(() => import("./pages/SessionPage"));
const CollectionPage = lazy(() => import("./pages/CollectionPage"));
const ParentPage = lazy(() => import("./pages/ParentPage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const DemoPage = lazy(() => import("./pages/DemoPage"));

export function App() {
  return (
    <>
      <OfflineNotice />
      <Suspense fallback={<div className="page-loading" role="status"><Nico compact /><p>Preparando a aventura…</p></div>}>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<LandingPage />} />
            <Route path="access" element={<AccessPage />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="demo" element={<DemoPage />} />
            <Route path="play" element={<WorldPage />} />
            <Route path="play/session/:sessionId" element={<SessionPage />} />
            <Route path="play/collection" element={<CollectionPage />} />
            <Route element={<AdultRoute />}>
              <Route path="parent" element={<ParentPage />} />
              <Route path="parent/settings" element={<SettingsPage />} />
              <Route path="parent/privacy" element={<PrivacyPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}
